import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "acDivider" }
const _hoisted_2 = { class: "acDivider_text" }


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AcDivider'
},
  __name: 'AcDivider',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "acDivider_line" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "acDivider_line" }, null, -1))
  ]))
}
}

})